import { IDeleteControlePatrimonioUseCase } from "../../../presentation/useCases/delete/delete_controle_patrimonio_use_case";
import { IControlePatrimonioRepository } from "../../repositories/ControledePatrimonio";

/**
 * DeleteControlePatrimonioUseCase
 */
export class DeleteControlePatrimonioUseCase implements IDeleteControlePatrimonioUseCase {
  constructor(private readonly repository: IControlePatrimonioRepository) { }

  async deleteControlePatrimonio(
    idMaquinaEquip: number,
  ): Promise<void> {
    await this.repository.deleteControlePatrimonio(idMaquinaEquip);
  }
}
